import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconPhoto } from '@tabler/icons-react';
import { cardImageUrl } from '../Shop_Functions/cloudinary';

// One shop piece: a 4:3 photo (see cardImageUrl), then title and price.
// Pieces with more photos show a count, and fade to the second photo on hover.
const ShopCard = ({ item, to }) => {
    const photos = item.image_url_arr;
    const hasMore = photos.length > 1;
    // Only fetch the second photo once someone hovers, so the grid doesn't load extra images
    const [hovered, setHovered] = useState(false);

    return (
        <Link
            to={to}
            onMouseEnter={hasMore ? () => setHovered(true) : undefined}
            className='group flex flex-col rounded-lg overflow-hidden bg-[#1A1B1E] no-underline transition-transform duration-200 hover:-translate-y-1'
        >
            <div className='relative'>
                <img
                    src={cardImageUrl(photos[0])}
                    alt={item.title}
                    loading='lazy'
                    className='block w-full aspect-[4/3] object-contain'
                />
                {hasMore && hovered &&
                    <img
                        src={cardImageUrl(photos[1])}
                        alt=''
                        className='absolute inset-0 w-full h-full object-contain opacity-0 transition-opacity duration-300 group-hover:opacity-100'
                    />
                }
                {hasMore &&
                    <span className='absolute top-2 right-2 inline-flex items-center gap-1 rounded-full bg-black/60 px-2 py-1 text-xs text-zinc-200'>
                        <IconPhoto size={14} aria-hidden='true' />
                        {photos.length} photos
                    </span>
                }
            </div>
            <div className='flex flex-row sm:flex-col justify-between items-baseline sm:items-start gap-2 sm:gap-1 px-4 py-3 sm:px-3'>
                <div className='text-white font-semibold sm:text-sm'>{item.title}</div>
                <div className='text-zinc-400 text-sm whitespace-nowrap'>$ {item.price}</div>
            </div>
        </Link>
    );
};

export default ShopCard
